import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


export default function AccordionExpandDefault() {
    return (
        <div className='mb-3 '>
            <Accordion sx={{ backgroundColor: 'var(--bs-secondary)', color: "var(--bs-primary)" }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <Typography>What is Eleganza Estate Solutions, and who is it for?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        <span style={{ fontWeight: 'bold' }}>Eleganza Estate Solutions</span> is the  <span style={{ fontWeight: 'bold' }}>best real estate agency in Bhopal</span>, exclusively
                        designed for buyers seeking<span style={{ fontWeight: 'bold' }}> premium apartments,</span> plots, and commercial spaces in
                        and around Bhopal. Whether you're looking for your dream home, a valuable plot, or
                        a high-end workspace, we specialise in delivering <span style={{ fontWeight: 'bold' }}> affordable luxury houses in
                            Bhopal</span> with unmatched service. Our commitment to transparency, expertise, and
                        client satisfaction makes us the trusted choice for premium real estate in Bhopal,
                        ensuring a seamless, rewarding, and hassle-free property-buying experience.

                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion sx={{ backgroundColor: 'var(--bs-secondary)', color: "var(--bs-primary)" }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                >
                    <Typography>What is the Zero Brokerage Policy, and how does it work?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        Our <span style={{ fontWeight: 'bold' }}>Zero Brokerage Policy</span> ensures you don’t pay any commission fees, making us
                        a trusted choice for zero brokerage real estate in Bhopal. This transparent and
                        cost-effective approach allows you to focus on finding your dream property without
                        hidden charges. At <span style={{ fontWeight: 'bold' }}>Eleganza Estate Solutions,</span> we redefine the real estate
                        experience by combining affordability, premium property options, and complete client
                        satisfaction.

                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion sx={{ backgroundColor: 'var(--bs-secondary)', color: "var(--bs-primary)" }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                >
                    <Typography>Do buyers need to pay any fees to Eleganza?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        No, buyers don’t pay any fees at all. With our Zero Brokerage Policy, there are no hidden charges—only premium listings and exceptional service .<br></br>
                        <span style={{ fontWeight: 'bold' }}>"At Eleganza, buying your dream property is free of extra costs—because great investments shouldn't come with high fees."</span>
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion sx={{ backgroundColor: 'var(--bs-secondary)', color: "var(--bs-primary)" }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                >
                    <Typography>What areas and types of properties do you specialise in?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        We specialise in <span style={{ fontWeight: 'bold' }}>luxury apartments,</span> spacious plots, and premium commercial
                        properties across Bhopal and surrounding areas. From prime <span style={{ fontWeight: 'bold' }}>Airport Road Bhopal</span>
                        properties to exclusive developments in the city’s most sought-after locations, our
                        curated real estate portfolio offers unmatched value. While Bhopal is our starting
                        point, our vision is to expand globally, delivering exceptional property opportunities to
                        buyers and investors worldwide.
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion sx={{ backgroundColor: 'var(--bs-secondary)', color: "var(--bs-primary)" }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                >
                    <Typography>What sets Eleganza apart from other real estate agencies?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        At <span style={{ fontWeight: 'bold' }}>Eleganza Estate Solutions,</span> we believe in simplicity, transparency, and delivering
                        exceptional service. Our Zero Brokerage Policy ensures <span style={{ fontWeight: 'bold' }}>zero brokerage real
                            estate</span> transactions with no hidden fees—just straightforward, commission-free
                        deals. We offer a curated selection of luxury properties in real estate Bhopal, along
                        with personalised guidance, to make your property-buying journey effortless,
                        rewarding, and stress-free.
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion sx={{ backgroundColor: 'var(--bs-secondary)', color: "var(--bs-primary)" }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                >
                    <Typography>How do you guide buyers?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        Our deep understanding of the local market means we can provide clear, actionable advice on property trends, valuations, and opportunities—whether you’re buying a home or investing in real estate .                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion sx={{ backgroundColor: 'var(--bs-secondary)', color: "var(--bs-primary)" }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                >
                    <Typography>How do I get started, and is there a consultation fee?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        Starting your real estate journey with us is easy. Simply reach out through our
                        website or give us a call, and we’ll schedule a free consultation to understand your
                        requirements and present the best property options. From the first conversation to
                        the final handover, we’re here to simplify every step of the process with
                        transparency, expertise, and exceptional service.
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion sx={{ backgroundColor: 'var(--bs-secondary)', color: "var(--bs-primary)" }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                >
                    <Typography>How do I sell my property or list it on your platform?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        If you’re a property owner looking to sell or showcase your premium apartment, plot, or commercial space, reach out to us directly. We’ll guide you through the process and ensure it reaches discerning buyers .
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}
